import {
  ProfileChangeChannelInput,
  ProfileChangeResult,
  ProfileChangeTypeInput,
} from '@varo/graphql-schema-types';
import ProfileChange from 'services/graphql/mutations/ProfileChange';
import { useMutation } from 'urql';

const useProfileChange = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<{
    profileChange: ProfileChangeResult;
  }>(ProfileChange);

  const profileChange = async (
    changeRequest: Record<string, unknown>,
    profileChangeType: ProfileChangeTypeInput,
    channelType: ProfileChangeChannelInput = ProfileChangeChannelInput.InApp,
  ) =>
    await executeMutation({
      input: {
        channelType,
        profileChangeRequest: {
          profileChangeType,
          ...changeRequest,
        },
      },
    });

  return {
    fetching,
    error,
    profileChange,
    profileChangeResponse: data?.profileChange,
  };
};

export default useProfileChange;
